/**
 *  ------------------------------------
 *  Imports
 *  ------------------------------------
 */
import { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';

import useMaintenanceBypass from 'hooks/useMaintenanceBypass';

import './TestModeBanner.scss';

/**
 *  ------------------------------------
 *  TestModeBanner Component
 *  ------------------------------------
 */
const TestModeBanner: FunctionComponent = () => {

    const [maintenanceBypass] = useMaintenanceBypass();

    if (!maintenanceBypass) {
        return null;
    }

    return (
        <section className="test-mode">
            <div data-container>
                <Trans i18nKey="common:test.mode.notice"></Trans>
            </div>
        </section>
    )
}

/**
 *  ------------------------------------
 *  Exports
 *  ------------------------------------
 */
export default TestModeBanner;
